export default __webpack_public_path__ + "static/12-88a7e0e15d534c99c612da337bea855c.webp";